import React, { useEffect, useState } from "react";
import mailIcon from "../assets/mail.svg";
import phonIcon from "../assets/phone.svg";
import whatsAppIcon from "../assets/whatsapp.svg";
import logo from "../assets/logo.png";
import VideoPlayer from "./VideoPlayer";

const Footer = () => {
  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 767) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }

      if (window.innerWidth > 767) {
        setIsDesktop(true);
      } else {
        setIsDesktop(false);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="z-20">
        <footer className="bg-[#D9D9D9] py-10  xl:px-[120px] md:px-[30px] sm:px-[30px]">
          <div className="flex flex-col lg:flex-row md:flex-col justify-center lg:justify-around lg:items-start items-center">
            <div className="flex flex-col justify-center items-center lg:items-start lg:mr-10 mb-8">
              <div className="border border-[#000] text-[#12141D] text-2xl font-bold font-lato py-2 px-6 mb-8 text-center lg:text-left">
                Resources
              </div>
              <div className="flex flex-col items-center lg:items-start  gap-2">
                {/* <a
                  href="/quickguide"
                  className="text-lg text-gray-700 hover:text-[#b70303]"
                >
                  Free Quick Guides
                </a> */}

                <VideoPlayer url="https://www.youtube.com/watch?v=HPUzFtfhJ8o&list=PLjoWECZpFSwKYu2VaEzPmy8H5C-8r9b53" />
              </div>
            </div>
            {isDesktop && (
              <div className="flex flex-col justify-center lg:items-start items-center md:mt-0 relative lg:mt-14">
                <div className="flex flex-col lg:flex-row w-full items-center gap-4 border border-[#000] p-6 ">
                  <div className="text-[#b70303] text-4xl font-bold font-lato text-center lg:text-left absolute bottom-16 left-10 px-6 bg-[#D9D9D9]">
                    NEED HELP?
                  </div>
                  <div className="flex items-center gap-2">
                    <img src={mailIcon} alt="mail icon" className="w-8 h-8" />
                    <a
                      href="mailto:sales@lifebankcares.com"
                      className="text-2xl text-black  hover:text-[#b70303]"
                    >
                      sales@lifebankcares.com
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <img src={phonIcon} alt="phone icon" className="w-8 h-8" />
                    <a
                      href="/"
                      className="text-2xl text-black  hover:text-[#b70303]"
                    >
                      0700-LIFEBANK
                    </a>
                  </div>
                  <div className="flex items-center gap-2">
                    <img
                      src={whatsAppIcon}
                      alt="WhatsApp icon"
                      className="w-8 h-8"
                    />
                    <a
                      href="/"
                      className="text-2xl text-black  hover:text-[#b70303]"
                    >
                      070054332265
                    </a>
                  </div>
                </div>
              </div>
            )}
            {isMobile && (
              <div>
                <div className="border border-[#000] text-[#b70303] text-2xl font-extrabold font-lato py-2 px-6 mb-8  text-center lg:text-left">
                  NEED HELP?
                </div>
                <div className="flex flex-col items-center p-3">
                  <img src={mailIcon} alt="mail icon" className="w-8 h-8" />
                  <a
                    href="mailto:sales@lifebankcares.com"
                    className="text-[22px] text-gray-700 hover:text-[#b70303]"
                  >
                    sales@lifebankcares.com
                  </a>
                </div>
                <div className="flex flex-col items-center p-3">
                  <img src={phonIcon} alt="phone icon" className="w-8 h8" />
                  <a
                    href="/"
                    className="text-[22px] text-gray-700 hover:text-[#b70303]"
                  >
                     0700-LIFEBANK
                  </a>
                </div>
                <div className="flex flex-col items-center p-3">
                  <img src={whatsAppIcon} alt="WhatsApp icon" className="w-8 h-8" />
                  <a
                    href="mailto:sales@lifebankcares.com"
                    className="text-[22px] text-gray-700 hover:text-[#b70303]"
                  >
                    070054332265
                  </a>
                </div>
              </div>
            )}
          </div>
        </footer>

        <div className="">
        <hr className="mt-[50px] w-3/4 mx-auto"/>
        </div>
      
        <div className="flex justify-around flex-col lg:flex-row md:flex-col sm:flex-col items-center py-10  xl:px-[120px] md:px-[30px] sm:px-[30px] gap-6">
          <div
            className="flex justify-center items-center cursor-pointer"
            onClick={handleBackToTop}
          >
            <img src={logo} alt="logo" className="w-[115px] h-[34px] " />
          </div>

          <div className="flex justify-center items-center ">
            <p className="text-center text-[#52525B] font-bold font-lato">
              © Copyright 2024, All Rights Reserved by LifeBank
            </p>
          </div>

          <div className="flex justify-center items-center gap-4">
            <a
              href="https://web.facebook.com/LifeBankNG?_rdc=1&_rdr"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://img.icons8.com/ios-filled/50/000000/facebook-new.png"
                alt="facebook icon"
                className="w-8 h-8"
              />
            </a>

            <a
              href="https://twitter.com/LifeBankNG"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://img.icons8.com/ios-filled/50/000000/twitter.png"
                alt="twitter icon"
                className="w-8 h-8"
              />
            </a>

            <a
              href="https://www.instagram.com/lifebankng/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://img.icons8.com/ios-filled/50/000000/instagram-new.png"
                alt="instagram icon"
                className="w-8 h-8"
              />
            </a>

            <a
              href="https://www.linkedin.com/company/lifebankcares/mycompany/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="https://img.icons8.com/ios-filled/50/000000/linkedin.png"
                alt="linkedin icon"
                className="w-8 h-8"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
